import { getUserInfo, getFunctions, getRoles } from '@/api/login'
import { getconfig } from '@/api/setting/my.js'
const user = {
  namespaced: true,
  state: {
    info: {},
    userRoles: [],
    preference: {}
  },
  getters: {
    userInfo: state => state.info,
    userRoles: state => state.userRoles,
    preference: state => state.preference
  },
  mutations: {
    SET_USER_INFO: (state, info) => {
      state.info = info
    },
    SET_USER_ROLES: (state, roles) => {
      state.userRoles = roles
    },
    GET_USER_ROLES: (state, roles) => {
      state.userRoles = roles
    },
    GET_PREFERENCE: (state, preference) => {
      state.preference = preference
    }
  },
  actions: {
    // 获取偏好设置
    getPreference ({commit}) {
      return new Promise((resolve, reject) => {
        getconfig().then(
          response => {
            commit('GET_PREFERENCE', response)
            resolve(response)
          },
          error => {
            reject(error)
          }
        )
      });
    },
    // 获取userInfo
    getInfo ({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(
          response => {
            commit('SET_USER_INFO', response)
            resolve(response)
          },
          error => {
            reject(error)
          }
        )
      })
    },
    // 获取角色权限
    GetRoles ({ commit }, data) {
      return new Promise((resolve, reject) => {
        let { roleId } = data
        getRoles(roleId)
          .then(response => {
            commit('GET_USER_ROLES', response)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 获取职能权限
    GetFunctions ({ commit }, data) {
      return new Promise((resolve, reject) => {
        let { functionId } = data
        getFunctions(functionId)
          .then(response => {
            // 全选 和 半选
            let auth = response
              .filter(a => a.isOn === 1 || a.isOn === 2)
              .map(a => a.code)
            commit('GET_USER_FUNCTIONS', auth)
            resolve(auth)
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js